<template>
  <div class="page main-background">
    <div class="sub-header">
      <h2>استعلام تجمیع خلافی خودرو</h2>
    </div>
    <div v-if="!loading">
      <div
        class="error-message"
        v-if="errorMessage"
        style="text-align: center; margin: 10px 10px 0"
      >
        <h3 class="loading-title text-color" v-html="errorMessage"></h3>
        <a class="input primary-btn" @click="$router.go(-1)">بازگشت</a>
      </div>

      <div v-if="!errorMessage && carFines && carFines.warningPrice == 0">
        <h2 class="page-title text-color">نتیجه استعلام خلافی خودرو</h2>
        <div
          class="fines-summary text-color border-color background-color card"
        >
          <div class="header-item">
            <div class="header-item-title">
              <h3>جمع کل مبلغ تخلفات</h3>
            </div>
            <div class="header-item-value">
              <h2>
                <span class="blue-text">0</span>
                ریال
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!errorMessage && carFines && carFines.warningPrice != 0">
        <h2 class="page-title text-color">نتیجه استعلام خلافی خودرو</h2>
        <div
          class="fines-summary text-color border-color background-color card"
        >
          <div class="header-item">
            <div class="header-item-title">
              <h3>جمع کل مبلغ تخلفات</h3>
            </div>
            <div class="header-item-value">
              <h2>
                <span class="blue-text">{{
                  carFines.warningPrice | separator | persian
                }}</span>
                ریال
              </h2>
            </div>
          </div>
        </div>
        <div>
          <div class="fines text-color border-color background-color">
            <table>
              <tr>
                <td class="fines-header">شماره پلاک</td>
                <td class="fines-header">مبلغ کل</td>
              </tr>
              <tr>
                <td v-if="carFines.plateChar">
                  {{ carFines.plateChar | persian }}
                </td>
                <td v-if="carFines.warningPrice">
                  {{ carFines.warningPrice | separator | persian }}
                </td>
              </tr>
              <tr>
                <td class="secondary-title">شماره قبض</td>
                <td class="secondary-title">شماره پرداخت</td>
              </tr>
              <tr>
                <td v-if="carFines.paperId">
                  {{ carFines.paperId | persian }}
                </td>
                <td v-if="carFines.paymentId">
                  {{ carFines.paymentId | persian }}
                </td>
              </tr>
              <tr v-if="carFines.priceStatus == 1">
                <td class="txt-center" colspan="3">
                  <a
                    href="#"
                    @click="
                      generatePaymentLink(
                        carFines.warningPrice,
                        carFines.paperId,
                        carFines.paymentId
                      )
                    "
                    type="button"
                    class="payment-button"
                    >پرداخت</a
                  >
                </td>
              </tr>
              <tr v-else>
                <td class="txt-center" colspan="3">
                  <span class="success-payment-button">پرداخت شده</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="alert-bg">
          <div class="alert-box">
            <img src="../../assets/img/logo-bg1.png" width="200px">
            <h3 class="textCenter">با عرض پوزش، سرویس‌های خلافی خودرو در حال حاضر غیرفعال هستند.</h3>
          </div>
        </div> -->
    <PayModal v-if="payFlag" :url="paymentUrl" @close="payFlag = false">
      <template v-slot:header> پرداخت قبض </template>
      <template v-slot:body>
        <lable style="font-size: 14px;">
          آیا از پرداخت قبض شماره {{ paperId }} به مبلغ
          {{ fineAmount | separator | persian }} ریال اطمینان دارید؟
        </lable>
      </template>
    </PayModal>
    <div v-if="loading">
      <h3 class="loading-title text-color loading-box">
        در حال دریافت استعلام تجمیع خلافی خودرو، لطفا شکیبا باشید...
      </h3>
      <loader />
    </div>
  </div>
</template>

<script>
import PayModal from "../../components/payModal.vue";
import api, { BaseUrl_New } from "../../service";
import loader from "../../components/inquiry/Loader";
import config from "@/config";
import { mapGetters } from "vuex";

export default {
  name: "violation-inquiry-all",
  components: {
    PayModal,
    loader,
  },
  props: {
    carId: {
      type: String,
      required: true,
    },
    newCar: {
      type: Array,
      required: false,
    },
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  data() {
    return {
      errorMessage: null,
      loading: false,
      carFines: null,
      baseUrl: BaseUrl_New,
      payFlag: false,
      fineAmount: "",
      paperId: "",
      client: 3,
      userInformation: "",
    };
  },
  methods: {
    generatePaymentLink(amount, billId, paymentId) {
      api
        .generateCarFinesPaymentLink(
          amount,
          billId,
          paymentId,
          config.sadadCallback
        )
        .then((response) => {
          this.errorMessage = "";
          this.payFlag = true;
          this.fineAmount = amount;
          this.paperId = billId;
          this.paymentUrl = response.data.data.redirectUrl;
        })
        .catch((err) => {
          this.errorMessage = err.response.data[0].message;
        });
    },
  },
  mounted() {
    this.loading = true;

    // this.carFines = {
    //   plateChar: '0',
    //   errorCode: '0',
    //   priceStatus: '0',
    //   paperId: '0',
    //   paymentId: '0',
    //   warningPrice: '0',
    // }

    // this.carFines = {
    //   plateChar: ' شخصي  ايران 20 ــ  917س62',
    //   errorCode: '0',
    //   priceStatus: '1',
    //   paperId: '6483154500190',
    //   paymentId: '0000084017484',
    //   warningPrice: '840000',
    // }
    if (this.carId != 0) {
      api
        .getViolationInquiryAll(this.client, this.carId)
        .then((response) => {
          console.log(response);
          if (response.data && response.data.status === 200) {
            this.carFines = response.data.data;
          } else {
            if (
              response.data &&
              response.data.messages &&
              response.data.messages.length > 0
            ) {
              this.errorMessage = response.data.messages[0];
            }
          }
        })
        .catch(() => {
          this.errorMessage =
            "متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.";
        })
        .finally(() => {
          this.loading = false;
        });
    } else {
      if (this.newCar) {
        //console.log(this.userInformation);
        this.newCar = this.newCar.split(",");
        api
          .getViolationInquiryAllByInfo(
            this.client,
            this.newCar[0],
            this.newCar[1],
            this.newCar[2],
            this.newCar[3],
            this.newCar[4],
            this.newCar[5],
            this.newCar[6]
          )
          .then((response) => {
            if (response.data && response.data.status === 200) {
              this.carFines = response.data.data;
            } else {
              if (
                response.data &&
                response.data.messages &&
                response.data.messages.length > 0
              ) {
                this.errorMessage = response.data.messages[0];
              }
            }
          })
          .catch((err) => {
            this.errorMessage =
              "لطفا دسترسی اینترنت خود را چک کرده و دوباره امتحان کنید.";
            this.errorMessage = err.response.data.messages[0];
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  },
};
</script>

<style scoped>
/* .page { padding-bottom: 20px; display: flow-root; background: url("~@/assets/img/police.png"); background-repeat: no-repeat; background-position: unset; background-size: 100px; background-position-y: 40px; min-height: 100%; } */
.loading-title {
  text-align: center;
}

.header-item {
  display: flex;
  line-height: 40px;
}

.header-item-title {
  flex: 1;
}

.txt-right {
  text-align: right;
}

.payment-button {
  border: solid 1px #09389f;
  background-color: #09389f;
  padding: 4px 20px;
  color: white;
  border-radius: 5px;
  margin: 10px 8px;
}

.success-payment-button {
  border: solid 1px #155724;
  background-color: #155724;
  padding: 4px 20px;
  color: white;
  border-radius: 5px;
  margin: 10px 8px;
}

.dark .blue-text {
  color: white !important;
}
</style>
